import { render, staticRenderFns } from "./M4_S15.vue?vue&type=template&id=422cd24f&scoped=true"
import script from "./M4_S15.vue?vue&type=script&lang=js"
export * from "./M4_S15.vue?vue&type=script&lang=js"
import style0 from "./M4_S15.vue?vue&type=style&index=0&id=422cd24f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422cd24f",
  null
  
)

export default component.exports